import React from 'react';
import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { Data } from 'service/util';

import PopMessage from 'component/pop-msg/PopMessage';

const tomorrow = Util.getToday().setHours(24,0,0,0);

class BatchPriceModal extends React.Component
{
  constructor(props)
  {
    super(props);

    let location = JSON.parse(JSON.stringify(Data.location)).map(l => ({...l, selected: false}));

    this.state = {
      location, // copy
      company: Data.company,
      district: Data.district,
      plan: Data.plan,
      vtype: Data.vtype,
      filter_dis: Data.district[0].cd,
      sel_company: Data.company[0].cd,
      sel_plan: '',
      effect: tomorrow,
      fee_add: 0, fee_mul: 1,
      salary_add: 0, salary_mul: 1,
    };

    this.renderRow = this.renderRow.bind(this);
    this.toggleAllLocations = this.toggleAllLocations.bind(this);
  }

  get selectedLocations()
  {
    return this.state.location.filter(l => l.selected).map(l => ({ srv_dis: l.srv_dis, srv_loc: l.srv_loc }));
  }

  toggleAllLocations()
  {
    if (this.state.filter_dis)
    {
      // check status
      let loc = this.state.location.filter(l => l.srv_dis == this.state.filter_dis)
      let all = !loc.reduce((r,x) => r&&x.selected, true);
      loc.forEach(l => l.selected = all);
    } else {
      // remove all
      this.state.location.forEach(l => l.selected = false);
    }
    this.forceUpdate();
  }

  updatePlan()
  {
    const {fee_add, fee_mul, salary_add, salary_mul} = this.state;
    const effect     = Util.ShortDate(this.state.effect); // force local time format
    const company    = this.state.sel_company;
    const plan       = this.state.sel_plan;
    const vh_type    = this.state.sel_vtype;
    const locations  = this.selectedLocations;
    if (0 === locations.length) {
      PopMessage.show('請先選擇調整地區。', '輸入錯誤', 'danger');
      return;
    }

    API.editPlanPriceBatch({ locations, company, effect, plan, vh_type, fee_add, fee_mul, salary_add, salary_mul }).then(resp => {
      if (resp.success) {

        PopMessage.show('已成功套用調整。', '成功', 'success');
      } else {
        PopMessage.show(resp.msg, '更新失敗', 'danger');
      }
    });
  }
  updateService()
  {
    const {fee_add, fee_mul} = this.state;
    const effect     = Util.ShortDate(this.state.effect); // force local time format
    const company    = this.state.sel_company;
    const plan       = this.state.sel_plan;
    const vh_type    = this.state.sel_vtype;
    const locations  = this.selectedLocations;
    if (0 === locations.length) {
      PopMessage.show('請先選擇調整地區。', '輸入錯誤', 'danger');
      return;
    }

    API.editServicePriceBatch({ locations, company, effect, plan, vh_type, fee_add, fee_mul }).then(resp => {
      if (resp.success) {

        PopMessage.show('已成功套用調整。', '成功', 'success');
      } else {
        PopMessage.show(resp.msg, '更新失敗', 'danger');
      }
    });
  }


  renderRow(l)
  {
    return (
      <label className="location grid-row" key={`loc-${l.srv_dis}${l.srv_loc}`}>
        <div><input type="checkbox" checked={ l.selected } onChange={ e=> { l.selected = e.target.checked; this.forceUpdate() }} /></div>
        <div>{ l.srv_dis }{ l.srv_loc }</div>
        <div>{ `${l.name_zh} ${l.name_en}`.trim() }</div>
      </label>
    );
  } // render row

  render()
  {
    // filter and sort
    let l_loc = this.state.filter_dis === ''
      ?this.state.location.filter(l => l.selected)
      :this.state.location.filter(l => l.srv_dis === this.state.filter_dis);

    return (
      <div className="price-loc">
        <div className="price-loc-panel">
          <label className="field">
            <strong>加價公式</strong>
            <p>新價格 = 今日價格 &times; 倍率 + 加價</p>
          </label>
          <label className="field">
            <strong>公司</strong>
            <select value={this.state.sel_company} onChange={ e=> this.setState({sel_company: e.target.value})}>
              { this.state.company.map(com =>
                <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>服務計剷</strong>
            <select value={this.state.sel_plan} onChange={ e=> this.setState({sel_plan: e.target.value})}>
              <option value="">全部</option>
              { this.state.plan.map(p =>
                <option key={`plan-${p}`} value={p}>{p}</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>車種</strong>
            <select value={this.state.sel_vtype} onChange={ e=> this.setState({sel_vtype: parseInt(e.target.value, 10)})}>
              <option value="0">全部</option>
              { this.state.vtype.map(vt =>
                <option key={`vh-${vt.id}`} value={vt.id}>{vt.id} - {vt.desc}</option>
              )}
            </select>
          </label>
          <label className="field">
            <strong>生效日期</strong>
            <DatePicker selected={this.state.effect} dateFormat="yyyy-MM-dd"
                        onChange={ d=> this.setState({effect: d}) }/>
          </label>
          <label className="field">
            <strong>月費加價</strong>
            <input type="number" value={this.state.fee_add} onChange={ e=> this.setState({fee_add: parseFloat(e.target.value) })}/>
          </label>
          <label className="field">
            <strong>月費倍率</strong>
            <input type="number" value={this.state.fee_mul} onChange={ e=> this.setState({fee_mul: parseFloat(e.target.value)})}/>
          </label>
          <label className="field">
            <strong>工資增加</strong>
            <input type="number" value={this.state.salary_add} onChange={ e=> this.setState({salary_add: parseFloat(e.target.value)})}/>
          </label>
          <label className="field">
            <strong>工資倍率</strong>
            <input type="number" value={this.state.salary_mul} onChange={ e=> this.setState({salary_mul: parseFloat(e.target.value)})}/>
          </label>

          <div className="action-panel">
            <div>
              <button className="btn blue" onClick={e=>this.updateService()}>調整至現有客戶</button>
            </div>
            <div>
              <button className="btn blue" onClick={e=>this.updatePlan()}>調整至屋苑</button>
            </div>
          </div>

          <p className="message yellow">*註* 工資調整只在屋苑生效</p>

        </div>
        <div className="price-loc-pick">
          <label className="field">
            <strong>地區</strong>
            <select value={this.state.filter_dis} onChange={ e=> this.setState({filter_dis: e.target.value})}>
              <option value="">已選擇</option>
              { this.state.district.map(d =>
                <option key={`dis-${d.cd}`} value={d.cd}>{d.cd} - {d.name}</option>
              )}
            </select>
          </label>
          <div className="location grid-row thead">
            <div><button className="btn-selall" onClick={this.toggleAllLocations}></button></div>
            <div>編號</div>
            <div>屋苑名稱</div>
          </div>
          <div className="tbody">
            { l_loc.map(this.renderRow) }
          </div>
        </div>
      </div>
    );
  } // render()


}

export default BatchPriceModal;
